import React from 'react';
import { Calendar, Palette, Scissors, Trophy, MapPin, Shield, CheckCircle2, MessageSquare, ChevronRight } from 'lucide-react';
import { processSteps, features } from '../mock';

const iconMap = { Calendar, Palette, Scissors, Trophy, MapPin, Shield, CheckCircle2, MessageSquare };

const Process = () => {
  return (
    <section id="hakkimizda" className="section">
      <div className="section-inner">
        <div className="section-head">
          <div className="section-label">Nasıl Çalışıyoruz</div>
          <h2 className="section-title">
            Mükemmeliyetin <span className="accent">4 Adımı</span>
          </h2>
        </div>
        <div className="process-grid">
          {processSteps.map((step) => {
            const Icon = iconMap[step.icon];
            return (
              <div key={step.number} className="process-card">
                <div className="process-icon">
                  <Icon size={24} />
                </div>
                <div className="process-number">{step.number}</div>
                <h3 className="process-title">{step.title}</h3>
                <p className="process-desc">{step.description}</p>
                <div className="process-highlight">
                  <ChevronRight size={16} /> {step.highlight}
                </div>
              </div>
            );
          })}
        </div>
        <div className="features-row">
          {features.map((f) => {
            const Icon = iconMap[f.icon];
            return (
              <div key={f.text} className="feature-item">
                <span className="feature-icon"><Icon size={18} /></span>
                {f.text}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
